export default __webpack_public_path__ + "static/bombe-a085a0a6631533f564bf640b0449c410.png";